import React from 'react'
import {BoxProps, useMultiStyleConfig, Text, VStack} from '@chakra-ui/react'
import {useIntl} from 'react-intl'

interface FindInBoutiqueTitleProps {
    selectSize?: boolean
}

/**
 * @name FindInBoutiqueTitle
 *
 * @component
 *
 * @description
 * Renders the title of the product size selector drawer.
 *
 * @returns {React.FC} - The rendered title component.
 */
const FindInBoutiqueTitle: React.FC<FindInBoutiqueTitleProps> = ({selectSize = false}: FindInBoutiqueTitleProps) => {
    const {formatMessage} = useIntl()
    const styles = useMultiStyleConfig('ProductFindInBoutique', {}) as Record<string, BoxProps>

    // Render both the title and subtitle exactly as authored in the translation JSON — no code-side case
    // transforms and no theme `_firstLetter`/`textTransform` rewriting. The copy team controls the casing.
    const DRAWER_TITLE = formatMessage({id: 'label.drawer.find.in.boutique', defaultMessage: 'Find in Boutique'})
    const DRAWER_SUBTITLE = formatMessage({id: 'label.requestsize.title', defaultMessage: 'Select your size'})

    return (
        <VStack {...styles.drawerHeaderWrapper}>
            <Text {...styles.drawerTitle} as={'h2'}>
                {DRAWER_TITLE}
            </Text>

            {selectSize && (
                <Text {...styles.drawerSubtitle} as={'h2'}>
                    {DRAWER_SUBTITLE}
                </Text>
            )}
        </VStack>
    )
}

export default FindInBoutiqueTitle
